/**
 *@overview 根据字段状态进行排序
 *@author [damon song]
 *@createDate [2020-06-26]
 *@arr {Array}}
 *@return [Sort_Array]
 *@TODO 进一步完善 高可用 简单明了 根据后续参数 进行逐一排序现现阶段只根据两个参数排序
 */
function statusSort (arr = [], field, number, secNumber) {
  const firstArr = []
  const lastArr = []
  arr.forEach((item) => {
    item[field] === number ? firstArr.unshift(item) : item[field] === secNumber ? firstArr.push(item) : lastArr.push(item)
  })
  return [...firstArr, ...lastArr]
}

/**
 *@overview 远传拉取datalist 匹配select option
 *@author [damon song]
 *@createDate [2020-07-30]
 *@arr {Array}}
 *@return [Sort_Array]
 *@TODO 需要进一步语义优化 以及可扩展性优化
 */
function changeFieldName (arr, value, name) {
  return arr.map((item) => {
    return { value: item[value], label: item[name], disabled: false }
  })
}

/**
 * 日期获取
 */
function formatDate (now) {
  const year = now.getFullYear() // 取得4位数的年份
  let month = now.getMonth() + 1 // 取得日期中的月份，其中0表示1月，11表示12月
  let date = now.getDate() // 返回日期月份中的天数（1到31）
  if (month < 10) { month = '0' + month }
  if (date < 10) { date = '0' + date }
  const hours = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
  const min = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
  const sec = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
  return year + "-" + month + "-" + date + ' ' + hours + ':' + min + ':' + sec //
}
function timeFormat (time) {
  const d = new Date(time.substr(0, 19))// 加入substr(0, 19)处理兼容ios报错NAN
  const year = d.getFullYear() // 年
  const month = d.getMonth() + 1 // 月
  const day = d.getDate() // 日

  const hh = d.getHours() // 时
  const mm = d.getMinutes() // 分
  const ss = d.getSeconds() // 秒

  let clock = year + "-"

  if (month < 10) { clock += "0" }

  clock += month + "-"

  if (day < 10) { clock += "0" }

  clock += day + " "

  if (hh < 10) { clock += "0" }

  clock += hh + ":"
  if (mm < 10) clock += '0'
  clock += mm + ":"

  if (ss < 10) clock += '0'
  clock += ss
  return (clock)
}

/**
 * 日期获取
 */
function yearformatDate (now) {
  const year = now.getFullYear() // 取得4位数的年份
  let month = now.getMonth() + 1 // 取得日期中的月份，其中0表示1月，11表示12月
  let date = now.getDate() // 返回日期月份中的天数（1到31）
  if (month < 10) { month = '0' + month }
  if (date < 10) { date = '0' + date }
  return year + "-" + month + "-" + date //
}
export { statusSort, changeFieldName, formatDate, timeFormat, yearformatDate }
